import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
// import cx from 'classnames';
import _ from 'lodash';
import style from './Tally.scss';

import Utils from './utils';

export const TallyTitle = ({ type }) => {
  const headingText =
    {
      videos: 'Viewed',
      quizzes: 'Quizzes',
      key: 'Self rating',
    }[type] || type;

  return (
    <div className={style.titleContainer}>
      <span className={style.indicatorTitle}>{headingText}</span>
    </div>
  );
};

TallyTitle.propTypes = {
  type: PropTypes.oneOf(['videos', 'quizzes', 'key', 'rating']),
};

export const TallyAvg = ({ value, max, percent, type }) => {
  let numValue = Number(value);

  if (isNaN(numValue)) {
    numValue = '?';
  } else if (percent) {
    numValue = Math.round10(numValue, 0);
  } else {
    numValue = Math.round10(numValue, -1);
  }
  const numMax = Math.round10(Number(max), 0);
  const buttonText = Utils.getTallyText(value, numMax, percent);
  let popoverText =
    {
      videos: `Your students have watched an average of ${numValue} out of ${numMax} videos in this lesson`,
      quizzes: `Your students scored an average of ${numValue} out of ${numMax} for all quizzes in this lesson`,
      key: `${numValue}% of your students feel they understand the key knowledge in this lesson`,
      rating: `Among the students who have rated their understanding of this lesson, the average is ${numValue}/5`,
    }[type] || '';

  if (type === 'rating' && value === null) {
    popoverText =
      'None of your students have rated their understanding of this lesson yet';
  }

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      shouldUpdatePosition
      overlay={<Popover id={_.uniqueId()}>{popoverText}</Popover>}
      rootClose
    >
      <button className={`button-legacy ${style.indicator}`}>
        {buttonText}
      </button>
    </OverlayTrigger>
  );
};

TallyAvg.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  percent: PropTypes.bool,
  type: PropTypes.oneOf(['videos', 'quizzes', 'key', 'rating']),
};
